import {
  seriesByFilter,
  statsByFlyway,
} from '@/content/data/raw/red-list-index';

import type {
  RedListIndexFilterId,
  RedListIndexFlywayId,
  RedListIndexSeriesId,
} from '@/constants/stateCharts';
import type { Locale } from '@/lib/i18n';

export type RedListIndexPoint = {
  year: number;
  index: number;
  /** Lower bound of the confidence interval (qn05). */
  lower: number;
  /** Upper bound of the confidence interval (qn95). */
  upper: number;
};

export type RedListIndexStats = {
  /** Species that genuinely improved (moved to lower risk). */
  improvedCount: number;
  /** Species that genuinely deteriorated (moved to higher risk). */
  deterioratedCount: number;
};

export type RedListIndexData = {
  seriesByFilter: Record<RedListIndexSeriesId, readonly RedListIndexPoint[]>;
  statsByFlyway: Record<RedListIndexSeriesId, RedListIndexStats>;
};

/**
 * Red List Index dataset — yearly series per filter + side stats.
 * `all` is the source aggregate. The separate Show all UI filter compares
 * each named flyway without requiring a synthetic dataset key.
 */
export const redListIndexData: RedListIndexData = {
  seriesByFilter,
  statsByFlyway,
};

export type RedListIndexChartProps = {
  locale: Locale;
  data?: RedListIndexData;
  flywayFilter?: RedListIndexFilterId;
  ariaLabel: string;
  showAllAriaLabel: string;
  flywayLabels: Record<RedListIndexFlywayId, string>;
  lowerRiskLabel: string;
  higherRiskLabel: string;
  tableCaption: string;
  flywayColumnLabel: string;
  yearColumnLabel: string;
  indexColumnLabel: string;
  lowerColumnLabel: string;
  upperColumnLabel: string;
};
